
import Downloader from './downloader'

export default {
  name: 'resourceDownloader',
  path: '/recruiting/resource-download',
  component: Downloader,
  meta: {
    noAuth: true,
    title: ''
  }
}
